// @flow
import * as Sentry from '@sentry/react'
import get from 'lodash/get'
import values from 'lodash/values'

export async function handleResponseError(response: Response, requestBody: {}) {
  const responseStatus = response?.status

  if (responseStatus === 400) {
    const errorMessage = get(
      values(get(requestBody, ['json', 'error'], {})),
      0,
      'Something went wrong'
    )
    const e = new Error(errorMessage)
    Sentry.captureException(e, {
      extra: requestBody,
    })
    throw e
  }

  if (responseStatus === 500) {
    const e = new Error('Something went wrong, please try again later')
    Sentry.captureException(e, {
      extra: requestBody,
    })
    throw e
  }

  Sentry.captureMessage('Unhandled response error', {
    extra: {
      url: response?.url,
      status: response?.status,
    },
  })
  throw new Error('Something went wrong')
}

export const keepMe = true
